import React, { useEffect, useRef, useState } from "react";

const DURACION_TOTAL = 45; // segundos
const MAX_REPETICIONES = 20;

// Franja de publicidades que corre sola de derecha a izquierda.
// Usa las publicidades de la asociación; si no tiene, repite el sponsor por defecto.
// entre: la franja va entre dos secciones, así que lleva también borde rojo arriba
export const SponsorsAsociacion = ({ publicidades = [], entre = false }) => {
  const contenedorRef = useRef(null);
  const listaRef = useRef(null);
  const [repeticiones, setRepeticiones] = useState(1);

  const items =
    publicidades.length > 0
      ? publicidades.map((item) => ({
          key: item.id,
          src: `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${item.id_asociacion}/IMAGENES/PUBLICIDAD/${item.imagen}`,
          alt: `Publicidad ${item.id}`,
        }))
      : Array.from({ length: 5 }, (_, i) => ({
          key: `default-${i}`,
          src: "/img/home/sponsor/sponsor2.png",
          alt: "Sponsor",
        }));

  // Cada "pista" tiene que ser más ancha que el contenedor para que el recorrido no tenga huecos.
  // Se vuelve a medir cada vez que carga una imagen, porque antes de cargar ocupan casi nada.
  const medir = () => {
    if (!contenedorRef.current || !listaRef.current) return;
    const anchoLista = listaRef.current.scrollWidth;
    if (!anchoLista) return;
    const necesarias = Math.ceil((contenedorRef.current.offsetWidth * 2) / anchoLista);
    setRepeticiones(Math.min(Math.max(necesarias, 1), MAX_REPETICIONES));
  };

  useEffect(medir, [publicidades]);

  const pista = (clave) => (
    <div
      key={clave}
      className="sponsors-asoc-pista"
      style={{ animationDuration: `${DURACION_TOTAL}s` }}
    >
      {Array.from({ length: repeticiones }).flatMap((_, r) =>
        items.map((item) => <img key={`${item.key}-${r}`} src={item.src} alt={item.alt} />)
      )}
    </div>
  );

  return (
    <div className={`sponsors-asoc${entre ? " sponsors-asoc--entre" : ""}`} ref={contenedorRef}>
      {/* lista de una sola vuelta, oculta, solo para medir cuánto ocupa */}
      <div className="sponsors-asoc-medida" ref={listaRef}>
        {items.map((item) => (
          <img key={item.key} src={item.src} alt="" onLoad={medir} />
        ))}
      </div>
      {pista("a")}
      {pista("b")}
    </div>
  );
};
